import { render, staticRenderFns } from "./excel-giftcards.vue?vue&type=template&id=66b75052&"
import script from "./excel-giftcards.vue?vue&type=script&lang=js&"
export * from "./excel-giftcards.vue?vue&type=script&lang=js&"
import style0 from "./excel-giftcards.vue?vue&type=style&index=0&id=66b75052&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports